export default __webpack_public_path__ + "static/blog-2-f35fcfd882dbe376c54ea512bbcb9959.jpg";